import { SyntheticEvent, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import jwtDecode from 'jwt-decode';
import { buildAdmin2faUrl } from '../../shared/helpers';
import { AccountSelectDto } from '../AccountSelect/models';
import { useGetAdminQuery } from '../People/TabsCard/AdminsTab/RemoveAdminModal/apiSlice';
import { userSelector } from '../../shared/store/shared/userSlice';
import { JwtDecodedUser } from '../../shared/models/UserModels';
import { resetHomeDeal } from '../../shared/store/shared/selectedHomeDealSlice';

export const ROLES = {
  'B2B:ADM': 'Administrator',
  'B2B:RPT': 'Reporter',
};

export default function AccountSwitcherMenuItem({
  account,
}: {
  account: AccountSelectDto;
}) {
  const dispatch = useDispatch();
  const { value: user } = useSelector(userSelector);
  const accessToken = user ? user.access_token : '';
  const authUser: JwtDecodedUser = jwtDecode(accessToken);
  const [isLoading, setLoading] = useState(false);
  const { data, isSuccess } = useGetAdminQuery({
    accountId: account.accountId,
    adminId: parseInt(authUser.id, 10),
  });

  const handleClick = (e: SyntheticEvent) => {
    setLoading(true);
    e.preventDefault();
    dispatch(resetHomeDeal());
    window.location.href = buildAdmin2faUrl(
      account.accountId,
      account.roleAssignmentId,
    );
  };

  return (
    <div
      aria-label={account.accountName}
      tabIndex={0}
      aria-checked={false}
      role="radio"
      key={account.accountId}
      className="account-switcher-menu-item p-3 cursor-pointer d-flex align-items-center"
      onClick={handleClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          handleClick(e);
        }
      }}
    >
      {isLoading ? (
        <Spinner size="sm" className="text-primary me-1" />
      ) : (
        <input type="radio" tabIndex={-1} readOnly className="me-2" />
      )}
      <div>
        <span className="small fw-bold text-primary">
          {account.accountName}
        </span>
        <div className="smaller text-muted">
          {isSuccess && ROLES[data?.accountRole?.roleId]}
        </div>
      </div>
    </div>
  );
}
